module.exports = __webpack_public_path__ + "img/axcess1_small_logo_v2.db988181.png";